var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contents-inner" }, [
    _c(
      "div",
      { staticClass: "col-type-01" },
      _vm._l(_vm.titles, function (title, i) {
        return _c(
          "div",
          { key: i, staticClass: "-block w49" },
          [
            _c("job-preview-button", {
              staticClass: "-middle",
              attrs: { title: title },
            }),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }